import React from "react"
import Footer from "../footer"

import openPicksShop from "../../utils/open-picks-shop"

class Footers extends React.Component {
  state = {
    place: "",
  }

  onChangePlace = e => {
    this.setState({ place: e.target.value })
  }

  onKeyPressPlace = e => {
    if (e.key === "Enter") {
      this.searchShop()
    }
  }

  searchShop = () => {
    openPicksShop(this.state.place)
  }

  render() {
    return (
      <div className="footers">
        <div data-aos="fade-up" className="background">
          <div className="inner">
            <div
              data-aos="fade-up"
              className="title has-text-centered has-text-white text-shadow"
            >
              オフィスや自宅近くのお店を
              <br />
              探してみよう
            </div>
            <div data-aos="fade-up" className="field has-addons box-shadow">
              <div className="control is-expanded">
                <input
                  className="input is-primary is-borderless is-shadowless"
                  type="text"
                  placeholder="地域名を入力にて店舗を探す.."
                  value={this.state.place}
                  onChange={this.onChangePlace}
                  onKeyPress={this.onKeyPressPlace}
                />
              </div>
              <div className="control">
                <a
                  className="button is-primary icon is-search"
                  onClick={e => {
                    this.searchShop()
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    )
  }
}

export default Footers
